import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_v522tftgx5: FaireBrandEntity = {
  token: "b_v522tftgx5",
  type: "brand",
  name: "FLUFFERY",
  avatarUrl:
    "https://cdn.faire.com/fastly/39f63825f2086c8a6a1c7f06efb97c06978231f4a8a0054ee0d2278b4847f8f9.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/fc5ea54eac4f4d45ad7ca49ca36465ce8f5e5acc3a2b91b6b3da92e187b51c80.png",
  logoUrl:
    "https://cdn.faire.com/fastly/39f63825f2086c8a6a1c7f06efb97c06978231f4a8a0054ee0d2278b4847f8f9.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/fc5ea54eac4f4d45ad7ca49ca36465ce8f5e5acc3a2b91b6b3da92e187b51c80.png",
  location: "New Brunswick, NJ, USA",
  minimumOrderDollars: 100,
  rating: 4.5,
  reviewCount: 69,
  isInsider: true,
  description:
    "At Fluffery, we’re all about the fluff. What started as a love for soft, squishy things quickly grew into a brand devoted to making the coziest plushies, throw blankets, and pillows you’ll ever cuddle. Every Fluffery item is designed to bring a little more comfort, a little more joy, and a whole lot more fluff into your everyday life.\n\nWe care deeply about quality and safety—so all of our plushies meet U.S. toy safety standards, including ASTM F963 and CPSIA. They’re safe for all ages, even babies under 3, and perfect for gifting, hugging, or keeping by your side for years to come.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T08:29:02.767Z",
    importedBy: "entity-db-cli",
  },
};
